import { render, staticRenderFns } from "./addWell.vue?vue&type=template&id=603cf5ed&scoped=true"
import script from "./addWell.vue?vue&type=script&lang=js"
export * from "./addWell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603cf5ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('603cf5ed')) {
      api.createRecord('603cf5ed', component.options)
    } else {
      api.reload('603cf5ed', component.options)
    }
    module.hot.accept("./addWell.vue?vue&type=template&id=603cf5ed&scoped=true", function () {
      api.rerender('603cf5ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wellManage/addWell/addWell.vue"
export default component.exports